export default __webpack_public_path__ + "static/media/tile_4.c7de119d.png";